<!-- 메인 -->
<template>
  <div class="mainBody">
    <emarticon-barcode v-if="showBarcode" :barcodeInfo="barcodeInfo" @toggleBarcodePopup="toggleBarcodePopup"></emarticon-barcode>
    <keyboard
      v-if="showKeyboard"
      @enterEmarticonPassword="enterEmarticonPassword"
      :certifiedRequestCount="certifiedRequestCount"
      :certifiedRestriction="emarticonMberPwdPolicy.certifiedRestriction"
      :certifiedRestrictionCount="emarticonMberPwdPolicy.certifiedRestrictionCount"
      :barcodeNo='barcodeInfo.prepaidCardNo'
      :showKeyboard='showKeyboard'
      @closeKeyboard="closeKeyboard"
      @closeKeyboardBio="closeKeyboardBio"
    />
    <emarticon-card :slide-data="cardList" v-on:toggleBarcodePopup="toggleBarcodePopup" classname="home-slide"></emarticon-card>
    <div class="MyCash" v-if="$store.state.mberInfo.mberNo">
      <ul>
        <li>
          나의 카드 <span>{{ prepaidCardOverview.totalCount }}</span
          >개
        </li>
        <li>
          잔액 <span>{{ prepaidCardOverview.totalRemainCash }}</span
          >원
        </li>
      </ul>
    </div>
    <button-box-main></button-box-main>
    <banner v-if="!newBanner" data="banner_emart_2408"></banner>
    <banner v-else data="banner_emart_2505"></banner>
    <!--      <banner data="banner_emart"></banner>-->
    <!--      <banner data="banner_emart_240604"></banner>-->
    <!--      <banner data="banner_emart_temp"></banner>-->
    <emarticon-list :goods-list="goodsList" :total-rows="goodsTotalRows" @getPrepaidCardGoods="getPrepaidCardGoods"></emarticon-list>
    <use-box :certified="emarticonMberPwdPolicy.certified" ></use-box>
    <alert-popup v-if="showAlertPopup === true" @confirmPopupClickConfirm="showAlertPopup = false" :message="alertPopupMessage"></alert-popup>
    <password-alert-popup v-if="showPasswordPopup === true" @confirmPopupClickConfirm="$confirmPopupClickConfirm" :message="alertMessage" />
    <password-alert-popup v-if="showError === true" @confirmPopupClickConfirm="showError = false" :message="alertMessage" />
    <password-confirm-popup v-if="showConfirmPopup === true" @confirmPopupClickNo="$confirmPopupClickNo" @confirmPopupClickYes="$confirmPopupClickConfirm" :message="alertMessage" :confirmPopupNoButton="confirmPopupNoButton" :confirmPopupYesButton="confirmPopupYesButton" />
    <guidance-period-popup v-if="showGuidancePeriodPeriod === true" @confirmPopupClickNo="showGuidancePeriodPeriod = false" @confirmPopupClickYes="$confirmPopupClickConfirm" @confirmPopupClickTomorrow="$confirmPopupClickTomorrow" :confirmTitle="confirmTitle" :confirmText="alertMessage" />
  </div>
</template>
<script>
import EmarticonCard from '@/components/common/EmarticonCard.vue';
import ButtonBoxMain from '@/components/common/ButtonBoxMain.vue';
import GrayLine from '@/components/common/GrayLine.vue';
import UseBox from '@/components/common/UseBox.vue';
import EmarticonList from '@/components/list/EmarticonList.vue';
import EmarticonBarcode from '@/views/home/emarticonBarcode.vue';
import apiList from '@/api/apiList';
import AlertPopup from '@/views/myemarticon/alertPopup';
import Banner from '@/components/common/Banner.vue';
import Keyboard from '@/components/common/Keyboard.vue';
import PasswordConfirmPopup from '@/views/myemarticon/passwordConfirmPopup.vue';
import PasswordAlertPopup from '@/views/myemarticon/passwordAlertPopup.vue';
import GuidancePeriodPopup from '@/views/myemarticon/guidancePeriodPopup.vue';
import commonScripts from '@/plugins/commonScripts';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default {
  name: 'emarticonHome',
  components: { GuidancePeriodPopup, PasswordConfirmPopup, EmarticonCard, ButtonBoxMain, GrayLine, EmarticonList, EmarticonBarcode, UseBox, Keyboard, AlertPopup, PasswordAlertPopup, Banner },
  data() {
    return {
      cardList: [],
      prepaidCardGoodsRequest: {
        orderCriteria: null,
        size: '10',
        pageNo: '1',
      },
      goodsList: [],
      goodsTotalRows: 0,
      prepaidCardBoxRequest: {
        orderCriteria: null,
        size: '10',
        pageNo: '1',
      },
      prepaidCardOverview: {
        totalCount: 0,
        totalRemainCash: 0,
      },
      showBarcode: false,
      barcodeInfo: null,
      /** @type {Boolean} 경고창 팝업 show 여부*/
      showAlertPopup: false,
      /** @type {String} 경고창 팝업 메시지 */
      alertMessage: '',
      alertPopupMessage: '',
      showConfirmPopup: false,
      showError: false,
      showPasswordPopup: false,
      showGuidancePeriodPeriod: false,
      confirmTitle: '',
      confirmPopupNoButton: '',
      confirmPopupYesButton: '',
      notToday: false,
      isAppUpdatedNeeded: false,
      showKeyboard: false,
      emarticonMberPwdPolicy: {
        ctmmnyNo: '',
        certified: false,
        passwordForce: false,
        certifiedRestriction: false,
        certifiedRestrictionCount: null,
      },
      emarticonMberPwdRequest: {
        certifiedType: 'PASSWORD',
        emarticonPassword: '',
        prepaidCardNo: this.prepaidCardNo,
      },
      certifiedRequestCount: '',
      newBanner: false,
    };
  },
  watch: {
    overflowVal(newValue, oldValue) {
      if (newValue) {
        // 마우스 스크롤 막기
        document.body.style.overflow = 'hidden';
      } else {
        // 마우스 스크롤 해제
        document.body.style.overflow = 'auto';
      }
    },
  },
  computed: {
    overflowVal() {
      return this.showPasswordPopup || this.showError || this.showConfirmPopup || this.showGuidancePeriodPeriod || this.showKeyboard;
    },
  },
  created() {
    // Netfunnel 버전 업그레이드로 현재 사용 버전 제거 - 추후 업그레이드 버전으로 작업 예정
    // let successNetfunnel = this.afterNetfunnel();
    //
    // NetFunnel_Action(
    //   { action_id: 'econ_main', skin_id: 'emart' },
    //   {
    //     success: function (ev, ret) {
    //       successNetfunnel;
    //       NetFunnel_Complete();
    //     },
    //   },
    // );
    this.afterNetfunnel();
  },
  destroyed() {
    window.popStateDetected = false;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    this.$heading('이마티콘');
    this.preventBack();

    //한국 시간 가져오기 위한 설정
    dayjs.extend(utc);
    dayjs.extend(timezone);

    //자동충전 혜택 변경 날짜 제한 설정
    const today = new Date(dayjs().tz('Asia/Seoul'));
    const beginDate = new Date('2025-05-15T15:00:00');

    if(today >= beginDate) {
      this.newBanner = true;
    }

    if (this.$store.state.mberInfo.mberNo) {
      await this.getPrepaidCardOverview();
    }
  },
  methods: {
    preventBack: function () {
      window.location.href = 'emart-today://goback/?enable=Y'; // 뒤로가기 허용
      window.location.href = 'emart-today://clear_history'; // 히스토리 클리어
    },
    /**
     * 카드 보관함 호출
     */
    async getPrepaidCardBox() {
      try {
        const res = await apiList.getPrePaidCardBox(this.prepaidCardBoxRequest);
        this.cardList = res.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    async afterNetfunnel() {
      await this.getAdminMberPwdPolicy();
      if (this.emarticonMberPwdPolicy.certified) {
        await this.showGuidancePeriod();
      }

      // 회원 카드 조회
      if (this.$store.state.mberInfo.mberNo) {
        this.getPrepaidCardBox();
      }
      this.getPrepaidCardGoods('BENEFIT_DESC');

      if (this.$route.query.code && this.$route.query.message) {
        this.alertPopupMessage = decodeURI(this.$route.query.message);
        this.showAlertPopup = true;
        this.$router.replace({ query: null });
      }
    },
    /**
     * 상품 페이지 조회 호출
     */
    async getPrepaidCardGoods(orderCriteria) {
      try {
        if (orderCriteria !== null && orderCriteria !== '') {
          this.prepaidCardGoodsRequest.orderCriteria = orderCriteria;
        }
        const res = await apiList.getPrepaidCardGoods(this.prepaidCardGoodsRequest);
        this.goodsList = res.data.data.list;
        this.goodsTotalRows = res.data.data.totalRows;
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 선불카드 개요 조회
     */
    async getPrepaidCardOverview() {
      try {
        const param = {
          mberNo: this.$store.state.mberInfo.mberNo,
          maximumRows: 150,
        };
        const res = await apiList.getPrepaidCardOverview(param);
        this.prepaidCardOverview.totalCount = res.data.data.totalCount;
        this.prepaidCardOverview.totalRemainCash = new Intl.NumberFormat('ko-KR', { style: 'decimal' }).format(res.data.data.totalRemainCash);
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 관리자 비밀번호 정책 조회
     */
    async getAdminMberPwdPolicy() {
      const adminRes = await apiList.getAdminMberPwdPolicy({ ctmmnyNo: this.$store.state.partnerId });
      this.emarticonMberPwdPolicy = adminRes.data.data;
      if (!this.emarticonMberPwdPolicy.certified) {
        this.$store.commit('setIsMberPwdAuthenticated');
      }
      if(this.$store.state.nativeStore.isApp) {
        this.setIsEmarticonPasswordEnabled();
      }
    },
    /**
     * 기간별 이마티콘 비밀번호 사용여부 설정
     */
    setIsEmarticonPasswordEnabled() {
      const device = this.$store.state.nativeStore.device;
      const appVer = this.$store.state.nativeStore.appVer;
      const today = new Date();

      const firstBeginDate = new Date('2025-01-21T00:00:00');
      const secondBeginDate = new Date('2025-02-17T00:00:00');
      const thirdBeginDate = new Date('2025-04-01T00:00:00');

      let isNewVersion;
      if (device === 'and') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.1.2');
      } else if (device === 'ios') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.0.9');
      }

      if (today < firstBeginDate) {
        this.isAppUpdatedNeeded = false;
      } else if (today >= firstBeginDate && today < secondBeginDate) {
        // 구버전: 비번/생체 사용 x
        // 신버전: 비번/생체 사용 가능
        this.isAppUpdatedNeeded = false;
        if (!isNewVersion) {
          this.emarticonMberPwdPolicy.certified = false;
          this.$store.commit('setIsMberPwdAuthenticated');
        }
      } else if (today >= secondBeginDate && today <= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용 가능
        this.isAppUpdatedNeeded = !isNewVersion;
      } else if (today >= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용
        this.isAppUpdatedNeeded = !isNewVersion;
      }
    },
    /**
     * 계도기간 팝업 노출
     */
    async showGuidancePeriod() {
      const device = this.$store.state.nativeStore.device;
      const appVer = this.$store.state.nativeStore.appVer;
      const today = new Date();

      let beginDate;
      const endDate = new Date('2025-04-01T00:00:00');
      const finalDate = new Date('2029-12-31T00:00:00');

      let isNewVersion;
      if (device === 'and') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.1.2');
      } else if (device === 'ios') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.0.9');
      }
      beginDate = device === 'web'? new Date('2025-01-14T00:00:00') : isNewVersion ? new Date('2025-01-21T00:00:00') : new Date('2025-02-17T00:00:00');

      if (today >= beginDate && today < endDate) {
        this.confirmTitle = '4월 1일부터는 사용을 위한<br> 비밀번호 설정이 필수입니다.';
        this.alertMessage = '편리한 사용을 위해서 미리 설정해 주세요.';
      } else if (today >= endDate && today <= finalDate) {
        this.confirmTitle = '비밀번호 미 설정 시 이마티콘 사용이 불가합니다.';
        this.alertMessage = '안전한 결제를 위해 설정해 주세요.';
      }

      const localData = atob(localStorage.getItem('deferPwd'));
      if (localData) {
        const todayFormat = today.toISOString().split('T')[0];
        if (todayFormat === localData) {
          return;
        } else {
          localStorage.removeItem('deferPwd');
        }
      }

      if (today >= beginDate && today <= finalDate) {
        const res = await apiList.postCheckPasswordExist();
        if (res.data === 'N') {
          this.showGuidancePeriodPeriod = true;
          this.notToday = true;
        }
      }
    },
    /**
     * 바코드 팝업 노출
     */
    async toggleBarcodePopup(barcodeInfo) {
      if (!this.showBarcode) {
        this.barcodeInfo = barcodeInfo;

        if (this.emarticonMberPwdPolicy.certified) {
          if (this.isAppUpdatedNeeded) {
            this.alertMessage = '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.';
            this.confirmPopupYesButton = '업데이트';
            this.confirmPopupNoButton = '닫기';
            this.showConfirmPopup = true;
            return;
          }

          // 비밀번호 설정 여부 조회
          this.emarticonMberPwdRequest.prepaidCardNo = this.barcodeInfo.prepaidCardNo;
          this.emarticonMberPwdRequest.certifiedType = 'PASSWORD';
          try {
            if (this.$store.state.isMberPwdAuthenticated) {
              await this.getPrepaidCardBox();
              this.showBarcode = !this.showBarcode;
            } else {
              const res = await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
              if (res.code === 'no.member.password.was.found') {
                if (!this.$store.state.isMberPwdAuthPass) {
                  if (this.emarticonMberPwdPolicy.passwordForce) {
                    this.alertMessage = '최초 1회 비밀번호 설정이 필요합니다.<br>비밀번호 설정으로 이동합니다.';
                    this.showPasswordPopup = true;
                  } else {
                    this.confirmPopupNoButton = '닫기';
                    this.confirmPopupYesButton = '비밀번호 설정';

                    const today = new Date();
                    const changeDate = new Date('2025-04-01T00:00:00');
                    if(today >= changeDate) {
                      this.alertMessage = '최초 1회 비밀번호 설정이 필요합니다.<br>비밀번호 설정으로 이동하시겠습니까?';
                    } else {
                      this.alertMessage = '4월 1일부터는 사용을 위한<br> 비밀번호 설정이 필수입니다.<br> 편리한 사용을 위해서 미리 설정해 주세요.';
                    }
                    this.showConfirmPopup = true;
                  }
                } else {
                  this.showBarcode = !this.showBarcode;
                }
              } else if (res.code === 'this.password.has.exceeded.the.maximum.number.of.certified.restriction.count') {
                this.alertMessage = `비밀번호를 <em>${res.message}회</em> 잘못 입력하셨습니다.<br>비밀번호 설정 화면으로 이동합니다.`;
                this.showPasswordPopup = true;
              } else {
                this.certifiedRequestCount = res.data.data.certifiedRequestCount;
                this.showKeyboard = true;
              }
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          this.showBarcode = !this.showBarcode;
        }
      } else {
        this.showBarcode = !this.showBarcode;
      }
    },
    /**
     * loginModal 값 변경 메소드
     * @param {boolean} loginModalFlag loginModal 플래그 값
     */
    updateloginModal(loginModalFlag) {
      this.loginModal = loginModalFlag;
      const bodyHtml = document.body;
      if (this.loginModal === true) {
        // 로그인 필요 팝업이 뜨면 스크롤 막기
        bodyHtml.style.overflow = 'hidden';
      } else {
        // 로그인 필요 팝업이 닫히면 스크롤 막기 해제
        bodyHtml.style.overflow = 'auto';
      }
    },
    /**
     * Confirm 팝업 예 클릭
     */
    $confirmPopupClickConfirm() {
      if (this.alertMessage === '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.') {
        const device = this.$store.state.nativeStore.device;
        if (device === 'and') {
          // 안드로이드일 경우
          let iframe = document.createElement('iframe');
          iframe.style.visibility = 'hidden';
          iframe.src = 'market://details?id=com.emart.today';
          document.body.appendChild(iframe);
          document.body.removeChild(iframe);
        } else if (device === 'ios') {
          // 아이폰일 경우
          location.replace('http://itunes.apple.com/kr/app/id397728319?mt=8');
        }
        this.showConfirmPopup = false;
      } else {
        this.showPasswordPopup = false;
        this.$router.push({ name: 'setting' });
      }
    },
    /**
     * Confirm 팝업 아니오 클릭
     */
    async $confirmPopupClickNo() {
      if (this.alertMessage === '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.') {
        this.showConfirmPopup = false;
      } else {
        this.$store.commit('setIsMberPwdAuthenticated');
        await this.decryptPrepaidCardNo();
        await this.getPrepaidCardBox();
        this.showConfirmPopup = false;
        this.showBarcode = !this.showBarcode;
      }
    },
    /**
     * 이마티콘 회원 비밀번호 설정 계도기간 팝업 오늘 보지 않기 클릭
     */
    $confirmPopupClickTomorrow() {
      const now = new Date().toISOString().split('T')[0];
      localStorage.setItem('deferPwd', btoa(now));
      this.showGuidancePeriodPeriod = false;
    },
    /**
     * 이마티콘 회원 비밀번호 입력
     */
    enterEmarticonPassword(password) {
      this.emarticonMberPwdRequest.emarticonPassword = password;
      this.checkEmarticonMberPassword();
    },

    /**
     * 이마티콘 회원 비밀번호 강제 미사용 닫기 처리
     */
    async closeKeyboard() {
      this.emarticonMberPwdRequest.emarticonPassword = '';
      if (!this.emarticonMberPwdPolicy.passwordForce) {
        this.$store.commit('setIsMberPwdAuthenticated');
        await this.decryptPrepaidCardNo();
        this.showBarcode = true;
      }

      this.showKeyboard = false;
    },

    /**
     * 이마티콘 회원 비밀번호 생체인증 성공 닫기 처리
     */
    async closeKeyboardBio() {
      this.emarticonMberPwdRequest.certifiedType = 'BIO';
      await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
      this.$store.commit('setIsMberPwdAuthenticated');
      await this.decryptPrepaidCardNo();
      await this.getPrepaidCardBox();
      this.showKeyboard = false;
      this.showBarcode = true;
    },

    /**
     * 이마티콘 회원 비밀번호 검증 API 호출
     */
    async checkEmarticonMberPassword() {
      try {
        this.emarticonMberPwdRequest.certifiedType = 'PASSWORD';
        const res = await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
        if (res.code === 'this.password.has.exceeded.the.maximum.number.of.certified.restriction.count') {
          this.alertMessage = `비밀번호를 <em>${this.emarticonMberPwdPolicy.certifiedRestrictionCount}회</em> 잘못 입력하셨습니다. <br> 비밀번호 설정으로 이동합니다.`;
          this.showKeyboard = false;
          this.showPasswordPopup = true;
        } else if (res.code === 'this.password.does.not.match') {
          if (this.emarticonMberPwdPolicy.certifiedRestriction) {
            this.certifiedRequestCount = res.message;
            this.alertMessage = `비밀번호를 <em>${res.message}회</em> 잘못 입력하셨습니다. <br> <em>${this.emarticonMberPwdPolicy.certifiedRestrictionCount}회</em> 오류 시 재설정이 필요합니다.`;
            this.showError = true;
          } else {
            this.certifiedRequestCount = null;
            this.alertMessage = `비밀번호를 잘못 입력하셨습니다.<br>비밀번호를 확인해 주세요.`;
            this.showError = true;
          }
        } else if (res.data.code === 'S00000') {
          // 모의해킹 조치 password 입력 없이도 성공 응답을 내려주고 있어 password 입력 건에 대해 별도 처리
          if(res.data.data.emarticonPassword === 'true') {
            this.showKeyboard = false;
            this.$store.commit('setIsMberPwdAuthenticated');
            await this.decryptPrepaidCardNo();
            await this.getPrepaidCardBox();
            this.showBarcode = true;
          } else {
            this.certifiedRequestCount = null;
            this.alertMessage = `비밀번호를 잘못 입력하셨습니다.<br>비밀번호를 확인해 주세요.`;
            this.showError = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async decryptPrepaidCardNo() {
      const decryptRes = await apiList.getPrepaidCardDecrypt({ prepaidCardNo: this.barcodeInfo.prepaidCardNo });
      this.barcodeInfo.prepaidCardNo = decryptRes.data.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/setup.scss';
@import '@/assets/styles/common/buttonBox.scss';
@import '@/assets/styles/common/useBox.scss';
</style>
